module.exports = __webpack_public_path__ + "assets/img/home-banner.cbeefe59.png";